import $ from "jquery";
import queryString from "query-string";

class JSRouter {
    static _init() {
        JSRouter.pages = {};
        JSRouter.always_pages = [];
    }

    static init() {
        JSRouter.handlePage();
    }

    static handlePage() {
        if ("undefined" === typeof JSRouter.pages[window.ADMIN_MODULE]) {
            console.log("No pages registered for ", window.ADMIN_MODULE);
            return;
        }
        let handlers = [];
        let regex;

        $.each(JSRouter.pages[window.ADMIN_MODULE], function (pattern, callbacks) {
            regex = new RegExp(pattern);
            if (regex.test(window.ADMIN_URL)) {
                let data = regex.exec(window.ADMIN_URL);
                data.shift();
                handlers = handlers.concat(callbacks.map((callback) => {
                    return {
                        callback: callback,
                        data: data.slice(0)
                    }
                }));
            }
        });

        let pageData = null;
        let $pageDatas = $("script.js-page-data[type='text/json']");
        if ($pageDatas.length > 0) {
            try {
                pageData = [];
                $pageDatas.each(function () {
                    pageData.push(JSON.parse($(this).text()));
                }).get();
                if (pageData.length === 1) {
                    pageData = pageData[0];
                }
            } catch (e) {
                console.error("Couldn't parse page data", e);
            }
        }

        $.each(JSRouter.always_pages, (_, callback) => {
            callback();
        });

        if (handlers.length > 0) {
            let getArgs = queryString.parse(window.location.search);

            console.log("Got " + handlers.length + " handlers for", window.ADMIN_MODULE, window.ADMIN_URL);
            $.each(handlers, (_, handler) => {
                try {
                    handler.callback(handler.data, $.isArray(pageData) ? pageData.slice(0) : $.extend(true, {}, pageData), getArgs);
                } catch (e) {
                    console.error("Admin Page handler caused error: ", e);
                }
            });
        } else {
            console.info("No admin page handlers for ", window.ADMIN_MODULE, window.ADMIN_URL);
        }
    }

    static register_always(callback) {
        JSRouter.always_pages.push(callback);
    }

    static register(module, urls, callback) {
        if (!$.isArray(urls)) urls = [urls];
        if ("object" !== typeof JSRouter.pages[module]) JSRouter.pages[module] = {};

        $.each(urls, (_, url) => {
            if ("string" === typeof url) url = new RegExp("^" + url + "$");
            let pattern = url.toString();

            let value = pattern.substr(1, pattern.length - 2);

            if ("undefined" === typeof JSRouter.pages[module][value]) {
                JSRouter.pages[module][value] = [];
            }

            JSRouter.pages[module][value].push(callback);
        })
    }
}

JSRouter._init();

export default JSRouter;
